module.exports = __webpack_public_path__ + "img/abacus_type_5.b5e5e8a1.png";